import React, { useEffect, useState } from 'react';
import { Button, Modal, Form, Input, DatePicker, Descriptions } from 'antd';
import CustomerPicker from "components/pickers/customer"
import InputNumber from "components/input-number"
import ImagePicker from "components/pickers/image/MultiImagePicker"
import DebtService from "services/debt"
import OrderService from "services/order"
import Info from "components/customer/Info"
import { useApp } from 'contexts/app';
import ComonFields from "./ComonFields"
import dayjs from 'dayjs';
const service = new DebtService();
const orderService = new OrderService();
const AddDebt = ({ onSaved, customer_id, open, onClose, orderID }) => {

    const [showModal, setShowModal] = useState(false);

    const { showLoading, prompt } = useApp();
    useEffect(() => {
        if (open) {
            loadData();
        }

    }, [open, orderID])
    const [data, setData] = useState([]);
    const [customer, setCustomer] = useState({})

    const loadData = async () => {
        showLoading(true);
        var order = await orderService.get({ id: orderID });
        setData(order);
        setCustomer(order.customer);
        form.setFieldsValue({ customer_id: order.customer_id, amount: order.total_amount, description: `Ghi nợ đơn hàng ${order.id}`, date: dayjs(), order_id: order.id });
        showLoading(false);
        setShowModal(true)



    }



    const [form] = Form.useForm();
    const { showNotify } = useApp();

    const handleOk = () => {

        form.submit();
    };

    const onFinish = async (values) => {
        await service.createDebt(values);
        showNotify("Đã ghi nợ");
        if (onSaved) {
            onSaved();
        }

        close();
    }
    const close = () => {
        setShowModal(false)
        onClose();
    }
    return (
        <>

            <Modal
                title="Ghi Nợ"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={showModal}
                onOk={handleOk}
                onCancel={close}
            >


                <Form
                    layout={"vertical"}
                    form={form}
                    onFinish={onFinish}

                >

                    <Form.Item name="customer_id" label="Khách hàng"
                        rules={[{ required: true, message: "Bạn phải chọn khách hàng" }]}
                    >
                        <CustomerPicker style={{ width: "100%" }} disabled={true}></CustomerPicker>
                    </Form.Item>
                    <Form.Item noStyle>
                        <Info phone={customer.phone} />
                    </Form.Item>

                    <ComonFields></ComonFields>

                    <Form.Item name="order_id" label="Mã đơn hàng"

                        rules={[{
                            required: true,
                            message: "Mã đơn hàng"
                        }]}
                    >
                        <Input placeholder="order_id" disabled={true} />
                    </Form.Item>



                </Form>



            </Modal>
        </>
    );
};
export default AddDebt;